/**
 * Employee Web — `/me/hr-letters` section layout route: the list and the
 * letter detail (the notification deep-link target). Self-surface, no
 * permission gate — the endpoints scope to the caller.
 */
import type { JSX } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/me/hr-letters")({
  staticData: { breadcrumb: { labelKey: "hr-letters:nav.my_letters" } },
  component: MeHrLettersRoute,
});

function MeHrLettersRoute(): JSX.Element {
  return <Outlet />;
}
